import React, { useState } from "react";
import PropTypes from "prop-types";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import mixpanelService from "common/mixpanel-service";
import pageData from "common/page-data";

const propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  menuClassName: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape({ divider: PropTypes.oneOf([true]).isRequired }),
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        link: PropTypes.string,
        onClick: PropTypes.func,
        target: PropTypes.string,
        action: PropTypes.string
      })
    ])
  ).isRequired
};

const ActionsDropdown = ({ label, icon, menuClassName = null, items }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = item => {
    if (item.action) {
      mixpanelService.track("Campaign.CampaignActionsClick", {
        ...pageData.get("mixpanelData"),
        action: item.action
      });
    }
    if (item.onClick) item.onClick();
  };
  return (
    <Dropdown isOpen={isOpen} toggle={() => setIsOpen(!isOpen)} className="w-100 mb-2">
      <DropdownToggle
        outline
        color="primary"
        size="md"
        className="btn-sharp w-100 text-left d-flex justify-content-between align-items-center overflow-hidden"
      >
        <span className="text-truncate">
          <i className={`fa fa-${icon} mr-2`} />
          {label}
        </span>
        <i className={`fa fa-chevron-${isOpen ? "up" : "down"} ml-2`} />
      </DropdownToggle>
      <DropdownMenu className={`w-100${menuClassName ? ` ${menuClassName}` : ""}`}>
        {items.map(item => {
          if (item.divider) return <DropdownItem key={`divider-${item.label}`} divider />;
          if (item.onClick)
            return (
              <DropdownItem
                className="text-truncate"
                key={item.label}
                onClick={() => handleClick(item)}
              >
                {item.label}
              </DropdownItem>
            );
          return (
            <DropdownItem
              className="text-truncate"
              key={item.label}
              tag="a"
              href={item.link}
              target={item.target}
              onClick={() => handleClick(item)}
            >
              {item.label}
            </DropdownItem>
          );
        })}
      </DropdownMenu>
    </Dropdown>
  );
};

ActionsDropdown.propTypes = propTypes;

export default ActionsDropdown;
